//@ts-check
import { initContext } from "./init";

/**
 * 
 * @param {string} type 
 * @param {(widget: HTMLElement, data: any) => void} callback
 * @param {"ready" | "render" } by
 */
export function onReadyWidgetOfType(type, callback, by = "ready") {
    // console.log("[onReadyWidgetOfType]", { type, by })
    initContext.initialisers.set(type, callback)
}


export function historyBack() {
    const hasHistory = history.length > 1 && document.referrer.indexOf(location.origin) === 0

    if (hasHistory) {
        // If there's history and the referrer is from the same origin, go back
        history.back();
    } else {
        // No relevant history, redirect to parent path
        location.href = '../';
    }
}


export function setQueryParam(key, value) {
    // Get the current URL
    const currentUrl = new URL(location.href);

    // Set the query parameter
    currentUrl.searchParams.set(key, value);

    // Update the URL without reloading the page
    history.pushState({ path: currentUrl.href }, '', currentUrl.href);
}

export function getDateString(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export async function awaitAnimationFrames(count = 1) {
    for (let index = 0; index < count; index++) {
        await new Promise(resolve => requestAnimationFrame(resolve));
    }
}

/**
 * @param {HTMLElement} el
 */
export function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    // Check if the element is within the visible viewport
    const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= viewportHeight &&
        rect.right <= viewportWidth;

    return isInViewport;
}
